import { useEffect } from 'react';
import { FilterType } from '@/models/filter/FilterType';
import { setLocalOptionPaths } from '@/models/filter/utils/localOptionPathsStore';
import { SelectItem } from '@/types/ui/selectItem';

/**
 * Records a local hierarchical filter's resolved option universe. Written from
 * an effect, not `processOptions`: that runs in the query's render-phase
 * `select`, and the filter hooks subscribe to the store it writes.
 */
export const useRecordLocalOptionPaths = (filterKey: FilterType, options: SelectItem[], enabled: boolean): void => {
  useEffect(() => {
    if (!enabled || options.length === 0) return;
    const allPaths: string[] = [];
    for (const option of options) {
      if (typeof option.value === 'string') allPaths.push(option.value);
    }
    if (allPaths.length) setLocalOptionPaths(filterKey, allPaths);
  }, [enabled, filterKey, options]);
};
